<!-- MPAS VIEW -->
<div class="page">
  <section class="page-main">
    <div class="page-center">
      <main class="page-content" id="content" role="main">
        <div>
          <app-header [loggedIn]="loggedIn" *ngIf="loggedIn" (selectedOrganization)="selectedOrganization($event)">
          </app-header>
        </div>
      </main>
    </div>
  </section>
  <span class="overlay"></span>
  <div class="row" [ngClass]="loggedIn ? 'active-page layout' : ''" id="middle-content">
    <router-outlet></router-outlet>
  </div>
</div>
<kendo-dialog title="Confirm Log Out" id="confirmLogoutDialog" *ngIf="loggedIn && openLogOut" (close)="logOutClose()">
  <p class="important">Due to inactivity, session is about to expire in <strong>{{displayTime}}</strong></p>
  <kendo-dialog-actions>
    <button kendoButton (click)="logOutClose()">Stay Logged In</button>
    <button kendoButton class="k-button k-primary" (click)="logout(true)">Log Off</button>
  </kendo-dialog-actions>
</kendo-dialog>
<!-- FOOTER -->
<div class="site-footer" id="main-footer">
  <app-footer *ngIf="loggedIn" [selectedOrg]="selectedOrg"></app-footer>
</div>
